"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnershipInterstitialBase = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const tracker_1 = require("../../../tracker");
const features_1 = require("../../../features");
const useDismissInterstitial_hook_1 = require("../../../interstitial/hooks/useDismissInterstitial.hook");
const usePartnershipInterstitialBase = ({ partnershipData: { roleData } }) => {
    const { roleType, url } = roleData;
    const history = (0, react_router_dom_1.useHistory)();
    const [isOpen, setIsOpen] = React.useState(true);
    const { dismissInterstitialCall } = (0, useDismissInterstitial_hook_1.useDismissInterstitial)();
    React.useEffect(() => {
        tracker_1.tracker.track(features_1.PartnershipTrackingActions.PARTNERSHIP_INTERSTITIAL_OPEN_MODAL, { roleType });
    }, []);
    const handleCrossClose = () => {
        tracker_1.tracker.track(features_1.PartnershipTrackingActions.PARTNERSHIP_INTERSTITIAL_CROSS_ICON, { roleType });
        setIsOpen(false);
    };
    const handleDismissButton = () => {
        tracker_1.tracker.track(features_1.PartnershipTrackingActions.PARTNERSHIP_INTERSTITIAL_DISMISS_LINK, { roleType });
        dismissInterstitialCall(features_1.InterstitialsTypes.VERHYS);
        setIsOpen(false);
    };
    const handleGoToPartnershipAccount = () => {
        tracker_1.tracker.track(features_1.PartnershipTrackingActions.PARTNERSHIP_INTERSTITIAL_CONTINUE_BUTTON, { roleType });
        history.push(url);
    };
    return {
        handleGoToPartnershipAccount,
        handleCrossClose,
        handleDismissButton,
        isOpen,
        roleData,
    };
};
exports.usePartnershipInterstitialBase = usePartnershipInterstitialBase;
//# sourceMappingURL=usePartnershipInterstitialBase.hook.js.map